export default {
  beforeMount(el) {
    el.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  },
  unmounted(el) {
    el.removeEventListener('contextmenu', (e) => {
      e.preventDefault();
    });
  },
};
